// DatePickerFromTo.jsx
'use client';

import React, { useMemo, useCallback } from 'react';
import SmartDateField from '../../DatePickers/SmartDateField';

const pad = (n) => String(n).padStart(2, '0');
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const DatePickerFromTo = (props) => {
  const {
    filter,
    setFilter,
    placeholder, // "Depart" | "Arrived" (assumed)
    error,
    helperText,
  } = props;

  // Determine which field we're editing
  const fieldKey = placeholder === 'Depart' ? 'depart' : 'arrived';

  // Current value as "YYYY-MM-DD" or ''
  const value = filter?.[fieldKey] ? String(filter[fieldKey]) : '';

  // Compute min date:
  // - Depart: today
  // - Arrived (way === 2): max(today, filter.depart); else today
  const minDate = useMemo(() => {
    const t = todayStr();
    if (fieldKey === 'depart') return t;

    if (filter?.way === 2 && filter?.depart) {
      // choose the later of today vs depart
      return t > filter.depart ? t : filter.depart;
    }
    return t;
  }, [fieldKey, filter?.way, filter?.depart]);

  const onChange = useCallback(
    (next /* "YYYY-MM-DD" */) => {
      setFilter((prev) => ({
        ...prev,
        [fieldKey]: String(next || ''),
      }));
    },
    [setFilter, fieldKey]
  );

  return (
    <div>
      <div
        className="input-style-check items-center"
        style={{
          width: '100%',
          padding: 2,
          borderColor: error ? 'red' : undefined,
        }}
      >
        <SmartDateField
          type="date"
          value={value}
          setValue={onChange}
          minDate={minDate}
          showHint={false}
          fullWidth
          sx={{
            border: 'none',
            fontSize: 14,
          }}
          placeholder={placeholder}
        />
      </div>

      {error && <div style={{ color: '#d32f2f' }}>{helperText}</div>}
    </div>
  );
};

export default DatePickerFromTo;
